var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('HeroPage',{attrs:{"title":_vm.title,"description":_vm.description}}),_c('Breadcrumb',{attrs:{"list":_vm.breadcrumbList}}),_c('section',[_c('div',{staticClass:"section-container"},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }